import { memo, useState } from 'react';

import classes from './chip.module.scss';

interface IChipProps {
  title: string;
  color: string;
  hoverColor?: string;
  textColor: string;
  hoverTextColor?: string;
}

function Chip({
  title,
  color,
  hoverColor,
  textColor,
  hoverTextColor,
}: IChipProps) {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <div
      style={{ backgroundColor: isHovered && hoverColor ? hoverColor : color }}
      className={classes.chip}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <p style={{ color: isHovered ? hoverTextColor : textColor }}>{title}</p>
    </div>
  );
}

export default memo(Chip);
